import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Tracking } from '../../../_models/tracking';



@Component({
  selector: 'app-tracking',
  templateUrl: './tracking-list.component.html'
})
export class TrackingListComponent implements OnInit {

  title: string;
  subtitle: string;

  fromDate: Date;
  toDate: Date;

  deleteModal: boolean;

  searchTrackingForm: FormGroup;

  @Input() trackings: Tracking[];
  @Input() currentTracking: Tracking;
  @Input() filterFields: any;
  @Output() searchTrackings = new EventEmitter<any>();
  @Output() selectTracking = new EventEmitter<Tracking>();
  @Output() deleteTracking = new EventEmitter<Tracking>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder
  ) {}

  // convenience getter for easy access to form fields
  get f() { return this.searchTrackingForm.controls; }

  ngOnInit() {

    this.title = 'Módulo de Historicos';
    this.subtitle = 'Listado de Historicos';

    this.fromDate = new Date();

    // Colocamos la fecha inicial de búsqueda siete días atrás.
    this.fromDate.setDate(this.fromDate.getDate() - 7);

    this.toDate = new Date();

    // this.toDate.setMinutes(this.toDate.getMinutes() + (13 * 60));

    this.deleteModal = false;

    if (this.filterFields['f_date'] === undefined || this.filterFields['f_date'] === null) {
      this.filterFields['f_date'] = this.fromDate;
    }

    if (this.filterFields['f_date2'] === undefined || this.filterFields['f_date2'] === null) {
      this.filterFields['f_date2'] = this.toDate;
    }

    this.searchTrackingForm = this.formBuilder.group({
      f_username: this.filterFields['f_username'],
      f_action_name: this.filterFields['f_action_name'],
      f_permissions: this.filterFields['f_permissions'],
      f_field: this.filterFields['f_field'],
      f_date: this.filterFields['f_date'],
      f_date2: this.filterFields['f_date2'],
      // f_value: this.filterFields['f_value'],
      // f_new_value: this.filterFields['f_new_value'],
      f_user_id: null
    });
  }

  // NOTA: función que coge los parámetros del formulario y los "emite" fuera.
  buttonGetTrackingList(): void {
    console.log('-->--> Pulsado botón Buscar Clientes.');

    // this.searchTrackings.emit({
    //   f_name: this.f.f_name.value,
    //   f_reference: this.f.f_reference.value || null,
    //   f_name: this.f.f_name.value || null
    // });

    // Se inicializa a un id de usuario con el que nunca pueda devolver información al hacer la consulta.
    let userIdAux = 9999999;

    let current_user_id = Number(localStorage.getItem('user_id'));

    // Si existe usuario logueado se coge su id para filtrar en la consulta.
    if (current_user_id !== null && current_user_id !== undefined) {
      userIdAux = current_user_id;
    }

    // NOTA: Si quisiéramos que sólo mostrara los históricos que hizo el usuario que está logueado.
    // this.searchTrackingForm.controls.f_user_id.setValue(userIdAux);

    this.searchTrackings.emit(this.searchTrackingForm.value);
  }

  buttonCreateTracking() {
    this.selectTracking.emit(null);
    this.router.navigate(['/tracking-edit']);
  } // End function buttonCreateTracking

  buttonSetCurrentTracking(tracking: Tracking | null) {
    console.log('-> -> Seleccionado Cliente:');
    console.log(tracking);

    this.selectTracking.emit(tracking);

    this.router.navigate(['/tracking-edit']);
  } // End function buttonSetCurrentTracking

  buttonDeleteTracking(tracking: Tracking) {
    console.log('-> -> Borrar Cliente:');
    console.log(tracking);

    this.selectTracking.emit(tracking);

    this.showDeleteModal(true);

  } // End function buttonDeleteTracking

  showDeleteModal(value: boolean) {
    this.deleteModal = value;

  } // End function showDeleteModal

  confirmDeleteTracking() {
    this.deleteTracking.emit(this.currentTracking);
    this.showDeleteModal(false);
  }
} // End class TrackingListComponent
